// src/components/home/HowItWorks.tsx
import React from "react"
import { useTranslation } from "react-i18next"
import { FaUserPlus, FaWallet, FaExchangeAlt } from "react-icons/fa"
import "./style/HowItWorks.scss"

type StepConfig = {
  icon: JSX.Element
  key: string      // i18n key path suffix
}

// list icons + translation key suffixes
const stepConfigs: StepConfig[] = [
  { icon: <FaUserPlus />, key: "createAccount" },
  { icon: <FaWallet />, key: "depositFunds" },
  { icon: <FaExchangeAlt />, key: "startTrading" }
]

const HowItWorks: React.FC = () => {
  const { t } = useTranslation()

  return (
    <section className="how-it-works">
      <h2>{t("home.howItWorks.title")}</h2>

      <div className="steps-container">
        {stepConfigs.map((cfg, idx) => (
          <div key={idx} className="step-box">
            <div className="step-icon">{cfg.icon}</div>
            <h3 className="step-title">
              {t(`home.howItWorks.steps.${idx}.title`)}
            </h3>
            <p className="step-desc">
              {t(`home.howItWorks.steps.${idx}.description`)}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default HowItWorks
